import { usePropertyDefinition } from './usePropertyDefinition';
import { isFile } from 'customer-data-objects/property/PropertyIdentifier';
import { useGetIsUngated } from './useGetIsUngated';
import { FILE_TYPE_ENHANCED_UX_GATE } from '../../files/constants';
export const useHideFloatingEditIcon = () => {
  const propertyDefinition = usePropertyDefinition();
  const getIsUngated = useGetIsUngated();
  return isFile(propertyDefinition) && getIsUngated(FILE_TYPE_ENHANCED_UX_GATE);
};